import React, { useContext, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';

const Basket = observer(() => {
    const { basket } = useContext(Context);

    useEffect(() => {
        basket.loadBasket();
    }, []);

    const handleUpdateQuantity = async (id, newQuantity) => {
        if (newQuantity < 1) return;
        // Обновляем количество (можно добавить API-вызов)
        const item = basket.devices.find(d => d.id === id);
        if (item) {
            item.quantity = newQuantity;
            // TODO: вызвать API для обновления количества
        }
    };

    const handleDeleteItem = async (id) => {
        await basket.removeDevice(id);
    };

    if (basket.loading) {
        return <div className="text-center mt-5">Загрузка корзины...</div>;
    }

    if (basket.devices.length === 0) {
        return (
            <Container className="mt-5 text-center">
                <h3>🛒 Корзина пуста</h3>
                <p>Добавьте товары в корзину, чтобы оформить заказ.</p>
            </Container>
        );
    }

    return (
        <Container className="mt-3 mt-md-4 px-2 px-md-3">
            <h2 className="mb-4">🛒 Корзина</h2>
            <Row>
                <Col xs={12} lg={8} className="mb-3 mb-lg-0">
                    {basket.devices.map(item => (
                        <Card key={item.id} className="mb-3">
                            <Card.Body>
                                <Row className="d-flex align-items-center">
                                    <Col xs={3} sm={2} className="mb-2 mb-sm-0">
                                        <Image 
                                            src={`/images/${item.img}`}
                                            width="100%"
                                            height="auto"
                                            style={{ 
                                                objectFit: 'cover',
                                                maxHeight: '80px',
                                                borderRadius: '10px'
                                            }}
                                            onError={(e) => {
                                                e.target.src = 'https://picsum.photos/80/80';
                                            }}
                                        />
                                    </Col>
                                    <Col xs={9} sm={4} className="mb-2 mb-sm-0">
                                        <h6 className="text-truncate" style={{ fontSize: '0.9rem' }}>{item.name}</h6>
                                        <small className="text-muted">{item.price} ₽</small>
                                    </Col>
                                    <Col xs={7} sm={4} className="mb-2 mb-sm-0">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <Button 
                                                variant="outline-dark" 
                                                size="sm"
                                                onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}
                                            >
                                                -
                                            </Button>
                                            <span className="mx-2">{item.quantity}</span>
                                            <Button 
                                                variant="outline-dark" 
                                                size="sm"
                                                onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}
                                            >
                                                +
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col xs={5} sm={2} className="text-end">
                                        <Button 
                                            variant="danger" 
                                            size="sm"
                                            onClick={() => handleDeleteItem(item.id)}
                                        >
                                            🗑️
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    ))}
                </Col>
                <Col xs={12} lg={4}>
                    <Card>
                        <Card.Body>
                            <h5>Итого: {basket.totalPrice} ₽</h5>
                            <Button variant="dark" className="w-100">
                                Оформить заказ
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
});

export default Basket;
